export const INFO_ICON_TOOLTIP_TEXT = 'Please use the following format to search for variants: chr-pos-ref-alt (GRCh38).';
export const PLACEHOLDER_TEXT = 'Search by gene, variant, or phenotype';
